import React, { useRef } from 'react';
import Classes from './Banners.module.scss';
import useBannerScaleToFit from './hooks/useBannerScaleToFit';
import useCollapseOnGhostBanner from './hooks/useCollapseOnGhostBanner';
import { FEED_BANNER_CREATIVE } from './constants/banners';

const BannerHomeRightContainer = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const slotRef = useRef<HTMLDivElement | null>(null);

  useCollapseOnGhostBanner(true, slotRef, containerRef);

  useBannerScaleToFit({
    isEnabled: true,
    containerRef,
    baseWidth: FEED_BANNER_CREATIVE.width,
    baseHeight: FEED_BANNER_CREATIVE.height,
  });
  return (
    <div id="banner-right-container" ref={containerRef} className={`hz-FeedBannerBlock ${Classes.bannerFeedItem}`}>
      <div id="banner-right" ref={slotRef} className={Classes.bannerScale} />
    </div>
  );
};

export default BannerHomeRightContainer;
